export default __webpack_public_path__ + "static/media/contextual-chocolate-lyte@2x.4eb309cd.png";